export default "__VITE_ASSET__Dmo6ZjAu__"